<template>
    <div v-if="show" class="modal-overlay" @click.self="$emit('close')">
        <div class="paywall-modal">
            <button @click="$emit('close')" class="close-btn">&times;</button>
            <div class="paywall-content">
                <h2>🔒 Premium Feature</h2>
                <p>Advanced analytics with filtering and sorting is available for Premium members.</p>
                <ul class="premium-features">
                    <li>✅ View all 161 topics</li>
                    <li>✅ Filter by module</li>
                    <li>✅ Sort by accuracy, attempts, or score</li>
                    <li>✅ Search topics</li>
                    <li>✅ Export data (coming soon)</li>
                </ul>
                <button class="upgrade-btn" @click="$emit('upgrade')">Upgrade to Premium</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PremiumPaywall',
    props: {
        show: {
            type: Boolean,
            required: true
        }
    },
    emits: ['close', 'upgrade']
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.paywall-modal {
    background: var(--bg-primary);
    border: 2px solid var(--text-secondary);
    padding: 40px;
    max-width: 500px;
    width: 90%;
    position: relative;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8);
}

.close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    background: none;
    border: none;
    color: var(--text-secondary);
    font-size: 30px;
    cursor: pointer;
    line-height: 1;
    padding: 0;
    width: 30px;
    height: 30px;
}

.paywall-content h2 {
    color: var(--text-secondary);
    margin-bottom: 15px;
    font-size: 28px;
}

.paywall-content p {
    color: var(--text-primary);
    margin-bottom: 20px;
    opacity: 0.9;
}

.premium-features {
    list-style: none;
    padding: 0;
    margin: 20px 0 30px;
}

.premium-features li {
    color: var(--text-primary);
    padding: 10px 0;
    border-bottom: 1px solid var(--accent);
    font-size: 15px;
}

.premium-features li:last-child {
    border-bottom: none;
}

.upgrade-btn {
    width: 100%;
    padding: 15px;
    background: var(--text-secondary);
    color: var(--bg-primary);
    border: none;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.3s, box-shadow 0.3s;
    text-transform: uppercase;
    letter-spacing: 2px;
}

.upgrade-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(254, 231, 179, 0.4);
}
</style>